// Статусы расположены приблизительно в том порядке, в котором проходит процесс автокредитования

export enum AltynBankStatus {
  WaitingBankResponse = 'waiting_bank_response',
  PreApproved = 'pre_approved',
  AcceptedAlternative = 'accepted_alternative',
  Approved = 'approved',
  ClientAccepted = 'client_accepted',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Error = 'error',
  WaitingOfFinancing = 'waiting_of_financing',
  MobileClient = 'mobile_client',
  FinancedPledgeMissing = 'financed_pledge_missing',
  FinancedWaitingForModificationBeforePledge = 'financed_waiting_for_modification_before_pledge',
  OnRework = 'on_rework',
  Financed = 'financed'
}

export enum BccBankStatus {
  WaitingBankResponse = 'waiting_bank_response',
  PreApproved = 'pre_approved',
  AcceptedAlternative = 'accepted_alternative',
  Approved = 'approved',
  ClientAccepted = 'client_accepted',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Error = 'error',
  WaitingOfFinancing = 'waiting_of_financing',
  FinancedPledgeMissing = 'financed_pledge_missing',
  FinancedWaitingForModificationBeforePledge = 'financed_waiting_for_modification_before_pledge',
  OnVerification = 'on_verification',
  OnRework = 'on_rework',
  Financed = 'financed'
}

export enum BerekeBankStatus {
  WaitingBankResponse = 'waiting_bank_response',
  PreApproved = 'pre_approved',
  AcceptedAlternative = 'accepted_alternative',
  Approved = 'approved',
  ClientAccepted = 'client_accepted',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Error = 'error',
  WaitingOfFinancing = 'waiting_of_financing',
  FinancedPledgeMissing = 'financed_pledge_missing',
  FinancedWaitingForModificationBeforePledge = 'financed_waiting_for_modification_before_pledge',
  OnRework = 'on_rework',
  Financed = 'financed'
}

export enum EuBankStatus {
  WaitingBankResponse = 'waiting_bank_response',
  AcceptedAlternative = 'accepted_alternative',
  Approved = 'approved',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Error = 'error',
  WaitingOfFinancing = 'waiting_of_financing',
  FinancedPledgeMissing = 'financed_pledge_missing',
  FinancedWaitingForModificationBeforePledge = 'financed_waiting_for_modification_before_pledge',
  WaitingForUploadFiles = 'waiting_for_upload_files',
  OnRework = 'on_rework',
  Financed = 'financed'
}

export enum EuBankV2Status {
  WaitingBankResponse = 'waiting_bank_response',
  AcceptedAlternative = 'accepted_alternative',
  Approved = 'approved',
  ClientAccepted = 'client_accepted',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Error = 'error',
  MobileClient = 'mobile_client',
  WaitingOfFinancing = 'waiting_of_financing',
  VehicleRegistration = 'vehicle_registration',
  WaitingForDocsConfirmation = 'waiting_for_docs_confirmation',
  OnRework = 'on_rework',
  RefundInProgress = 'refund_in_progress',
  Refunded = 'refunded',
  Financed = 'financed'
}

export enum FfbBankStatus {
  WaitingBankResponse = 'waiting_bank_response',
  PreApproved = 'pre_approved',
  AcceptedAlternative = 'accepted_alternative',
  Approved = 'approved',
  ClientAccepted = 'client_accepted',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Error = 'error',
  WaitingOfFinancing = 'waiting_of_financing',
  VehicleRegistration = 'vehicle_registration',
  FinancedPledgeMissing = 'financed_pledge_missing',
  FinancedWaitingForModificationBeforePledge = 'financed_waiting_for_modification_before_pledge',
  OnRework = 'on_rework',
  Financed = 'financed'
}

export enum ForteBankStatus {
  WaitingBankResponse = 'waiting_bank_response',
  AcceptedAlternative = 'accepted_alternative',
  Approved = 'approved',
  ClientAccepted = 'client_accepted',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Error = 'error',
  WaitingOfFinancing = 'waiting_of_financing',
  FinancedPledgeMissing = 'financed_pledge_missing',
  FinancedWaitingForModificationBeforePledge = 'financed_waiting_for_modification_before_pledge',
  WaitingForUploadFiles = 'waiting_for_upload_files',
  OnRework = 'on_rework',
  Financed = 'financed'
}

export enum HalykBankStatus {
  WaitingBankResponse = 'waiting_bank_response',
  AcceptedAlternative = 'accepted_alternative',
  Approved = 'approved',
  ClientAccepted = 'client_accepted',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Error = 'error',
  WaitingOfFinancing = 'waiting_of_financing',
  FinancedPledgeMissing = 'financed_pledge_missing',
  FinancedWaitingForModificationBeforePledge = 'financed_waiting_for_modification_before_pledge',
  OnRework = 'on_rework',
  Financed = 'financed'
}

// Статусы для КМФ банка не были взяты из базы данных. Эти прописаны как fallback
export enum KmfBankStatus {
  WaitingBankResponse = 'waiting_bank_response',
  PreApproved = 'pre_approved',
  AcceptedAlternative = 'accepted_alternative',
  Approved = 'approved',
  ClientAccepted = 'client_accepted',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Error = 'error',
  WaitingOfFinancing = 'waiting_of_financing',
  FinancedPledgeMissing = 'financed_pledge_missing',
  Financed = 'financed'
}

export enum SapaBankStatus {
  WaitingBankResponse = 'waiting_bank_response',
  AcceptedAlternative = 'accepted_alternative',
  Approved = 'approved',
  ClientAccepted = 'client_accepted',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Error = 'error',
  WaitingOfFinancing = 'waiting_of_financing',
  Financed = 'financed'
}

// Статусы для Solva банка не были взяты из базы данных. Эти прописаны как fallback
export enum SolvaBankStatus {
  WaitingBankResponse = 'waiting_bank_response',
  AcceptedAlternative = 'accepted_alternative',
  Approved = 'approved',
  ClientAccepted = 'client_accepted',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Error = 'error',
  WaitingOfFinancing = 'waiting_of_financing',
  Financed = 'financed'
}

// Статусы для MFO банка не были взяты из базы данных. Эти прописаны как fallback
export enum MfoBankStatus {
  WaitingBankResponse = 'waiting_bank_response',
  AcceptedAlternative = 'accepted_alternative',
  Approved = 'approved',
  ClientAccepted = 'client_accepted',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Error = 'error',
  WaitingOfFinancing = 'waiting_of_financing',
  Financed = 'financed'
}

export enum ShinhanBankStatus {
  WaitingBankResponse = 'waiting_bank_response',
  AcceptedAlternative = 'accepted_alternative',
  Approved = 'approved',
  ClientAccepted = 'client_accepted',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Error = 'error',
  WaitingOfFinancing = 'waiting_of_financing',
  FinancedPledgeMissing = 'financed_pledge_missing',
  OnRework = 'on_rework',
  Financed = 'financed'
}
